import { ElMessage } from "element-plus";
import router from "@/router/index";
import useLogin from "@/stores/login";
import { getInfo } from "@/request/api/login";

let isChecking = false;
let hasExpiredHandled = false;

/**
 * 登录过期统一处理：清除状态并引导重新登录
 */
export function handleLoginExpired(message = "登录已过期，请重新登录") {
  if (hasExpiredHandled) {
    return;
  }
  hasExpiredHandled = true;

  const login = useLogin();
  login.isLogin = false;
  login.token = "";
  login.agencyId = undefined;
  login.code = undefined;
  login.userId = undefined;
  login.roleId = -1;
  login.username = undefined;

  ElMessage.error(message);

  if (router.currentRoute.value.path !== "/login") {
    router.push({ path: "/login" });
  }

  setTimeout(() => {
    hasExpiredHandled = false;
  }, 3000);
}

/**
 * 校验本地登录态是否仍有效（调用 getInfo 验证 token）
 */
export async function validateLoginToken() {
  const login = useLogin();
  if (!login.isLogin || !login.token) {
    return true;
  }
  if (router.currentRoute.value.path === "/login") {
    return true;
  }
  if (isChecking) {
    return true;
  }

  isChecking = true;
  try {
    const res = await getInfo();
    if (!res || res.code === 401) {
      handleLoginExpired();
      return false;
    }
    return true;
  } catch {
    // HTTP 401 由 request 拦截器调用 handleLoginExpired
    return false;
  } finally {
    isChecking = false;
  }
}
